module.exports = __webpack_public_path__ + "8c1387e9091b143058a1f52f759677c2.jpg";